import { render, staticRenderFns } from "./CommunicationDetail.vue?vue&type=template&id=1a363a42&"
import script from "./CommunicationDetail.vue?vue&type=script&lang=ts&"
export * from "./CommunicationDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports